import { Button } from '@orobix/orobix-fe-components'
import axios, { AxiosResponse } from 'axios'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { BASE_URL } from '../../utils/api'
import { ObservationsParams } from '../Observations/types'
import { Observation } from './types'

type DownloadSelectedButtonProps = {
  selected: Observation[]
  params: ObservationsParams
}

export const DownloadSelectedButton = ({
  selected,
  params,
}: DownloadSelectedButtonProps) => {
  const { t } = useTranslation()
  const [isPreparingDownload, setPreparingDownload] = useState(false)

  const downloadSelectedObservations = () => {
    setPreparingDownload(true)
    axios
      .post(
        `${BASE_URL}/observations/download/`,
        { observation_ids: selected.map((observation) => observation.id) },
        { responseType: 'blob' }
      )
      .then((res: AxiosResponse) => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `observations.zip`)
        document.body.appendChild(link)
        link.click()
      })
      .catch(() => {
        toast.error('Error downloading observations')
      })
      .finally(() => setPreparingDownload(false))
  }

  return (
    <Button
      onClick={() => {
        downloadSelectedObservations()
      }}
      label={
        isPreparingDownload
          ? t('Downloading')
          : t('Download ({{count}})', { count: selected.length })
      }
      buttonType="button"
      type="default"
      loading={isPreparingDownload}
      disabled={selected.length === 0 || isPreparingDownload}
    />
  )
}
